// ----------------------------------------------------------------------------
// Section: Collections Carousel
// ----------------------------------------------------------------------------

import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

// Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_collections-carousel.scss';

// -------------------------------------
// Variables
// -------------------------------------

var SECTION_SELECTOR = '.collections-carousel';
var CAROUSEL_SELECTOR = '.carousel--collections-carousel';
var PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var DESKTOP_BREAKPOINT = 1024;
var instances = new Map();
function shouldUseCarousel(slidesCount) {
  if (window.innerWidth < DESKTOP_BREAKPOINT) return true;
  return slidesCount >= 5;
}
function setupSection(sectionEl, index) {
  var carousel = sectionEl.querySelector(CAROUSEL_SELECTOR);
  if (!carousel) return;
  var slidesCount = carousel.querySelectorAll('.swiper-slide').length;
  var progressFill = sectionEl.querySelector('.collections-carousel__progress-fill');
  var uniqueCarouselClass = "carousel--collections-carousel-".concat(index);
  var uniquePrevClass = "collections-carousel-btn-prev-".concat(index);
  var uniqueNextClass = "collections-carousel-btn-next-".concat(index);
  carousel.classList.add(uniqueCarouselClass);
  sectionEl.querySelectorAll(PREV_BUTTON_SELECTOR).forEach(btn => btn.classList.add(uniquePrevClass));
  sectionEl.querySelectorAll(NEXT_BUTTON_SELECTOR).forEach(btn => btn.classList.add(uniqueNextClass));
  instances.set(sectionEl, {
    index,
    slidesCount,
    carouselSelector: ".".concat(uniqueCarouselClass),
    prevSelector: ".".concat(uniquePrevClass),
    nextSelector: ".".concat(uniqueNextClass),
    progressFill,
    swiper: null
  });
  syncInstance(sectionEl);
}
function updateProgress(swiperInstance, fillEl) {
  if (!fillEl) return;
  var totalSlides = swiperInstance.slides.length;
  var slidesPerView = Number(swiperInstance.params.slidesPerView) || 1;
  var currentIndex = swiperInstance.activeIndex;
  var progress = Math.min((currentIndex + slidesPerView) / totalSlides * 100, 100);
  fillEl.style.width = "".concat(progress, "%");
}
function syncInstance(sectionEl) {
  var state = instances.get(sectionEl);
  if (!state) return;
  var {
    slidesCount
  } = state;
  var enable = shouldUseCarousel(slidesCount);
  sectionEl.classList.toggle('collections-carousel--static', !enable);
  if (!enable) {
    if (state.swiper) {
      state.swiper.destroy(true, true);
      state.swiper = null;
    }
    return;
  }
  if (state.swiper) return;
  state.swiper = new Swiper(state.carouselSelector, {
    modules: [Navigation, A11y, Keyboard],
    slidesPerView: 2,
    slidesPerGroup: 1,
    watchOverflow: true,
    keyboard: true,
    observer: true,
    observeParents: true,
    a11y: {
      slideRole: null
    },
    breakpoints: {
      [DESKTOP_BREAKPOINT]: {
        slidesPerView: 4.5
      }
    },
    navigation: {
      nextEl: state.nextSelector,
      prevEl: state.prevSelector
    },
    on: {
      init(swiperInstance) {
        updateProgress(swiperInstance, state.progressFill);
      },
      slideChange(swiperInstance) {
        updateProgress(swiperInstance, state.progressFill);
      }
    }
  });
}
document.querySelectorAll(SECTION_SELECTOR).forEach((sectionEl, index) => setupSection(sectionEl, index));